<template>
	<transition name="slide">
		<div v-if="visible" class="modal show d-block" tabindex="-1" @keydown.esc.prevent.stop="emitClose">
			<div class="modal-dialog container">
				<div class="modal-content">
					<div class="modal-header">
						<slot name="header"/>
						<button type="button"
								class="close"
								aria-label="Close"

								@click="emitClose">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<slot name="default"/>
					</div>
					<div class="modal-footer">
						<slot name="footer"/>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>


<script>

	export default {
		name: "Modal",
		props: {
			visible: {type: Boolean, default: false}
		},
		methods: {
			emitClose() {
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss">
	.modal-dialog {
		max-width: 83vw !important;
	}

</style>
